import { render, staticRenderFns } from "./AddCompanyContactModal.vue?vue&type=template&id=35f45629&scoped=true&"
import script from "./AddCompanyContactModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyContactModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyContactModal.vue?vue&type=style&index=0&id=35f45629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f45629",
  null
  
)

export default component.exports